export default "__VITE_ASSET__83KfwWJg__"